import React from 'react';

type IconProps = { className?: string };

const base = { width: 16, height: 16, viewBox: '0 0 16 16', fill: 'none', 'aria-hidden': true as const };

export function MenuFolderIcon({ className }: IconProps) {
  return (
    <svg {...base} className={className}>
      <path
        d="M2 4.5A1.5 1.5 0 0 1 3.5 3h2.879a1 1 0 0 1 .708.293L8.5 4.5H12.5A1.5 1.5 0 0 1 14 6v5.5A1.5 1.5 0 0 1 12.5 13h-9A1.5 1.5 0 0 1 2 11.5v-7Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuPencilIcon({ className }: IconProps) {
  return (
    <svg {...base} className={className}>
      <path
        d="M10.5 3.5 12.5 5.5 5.5 12.5H3.5V10.5l7-7Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path d="M9 5 11 7" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );
}

export function MenuCreditCardIcon({ className }: IconProps) {
  return (
    <svg {...base} className={className}>
      <rect x="2" y="4" width="12" height="8" rx="1.25" stroke="currentColor" strokeWidth="1.25" />
      <path d="M2 7h12" stroke="currentColor" strokeWidth="1.25" />
      <path d="M5 10h2.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );
}

export function MenuArchiveIcon({ className }: IconProps) {
  return (
    <svg {...base} className={className}>
      <path
        d="M3 4.5h10M4.5 4.5V3.5A1 1 0 0 1 5.5 2.5h5a1 1 0 0 1 1 1v1M5 7.5h6M4.5 4.5v6.5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V4.5"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuTrashIcon({ className }: IconProps) {
  return (
    <svg {...base} className={className}>
      <path
        d="M3.5 4.5h9M6 4.5V3.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1M6.5 7v4M9.5 7v4M4.5 4.5l.5 7.5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1l.5-7.5"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuMoreIcon({ className }: IconProps) {
  return (
    <svg {...base} className={className}>
      <circle cx="8" cy="3.5" r="1" fill="currentColor" />
      <circle cx="8" cy="8" r="1" fill="currentColor" />
      <circle cx="8" cy="12.5" r="1" fill="currentColor" />
    </svg>
  );
}
